//理解度ボタンを押したときのinsert
export function insertTextPageHis(status){
	let currentElem = null;
	if(document.getElementsByClassName("current").length > 0){
		currentElem = document.getElementsByClassName("current")[0];
	}
	else{
		currentElem = document.getElementById("pageNo1");
	}
	var textPageId = currentElem.value;
	var pageNoStr = currentElem.id;
	var pageNo = pageNoStr.substr(6,pageNoStr.length);
	var xhttp = new XMLHttpRequest();
	xhttp.onreadystatechange = function() {
	    if (this.readyState == 4 && this.status == 200) {
	    	var resp = this.responseText;
	    	if(resp == ""){
	    		console.log("update underStand level fail")
	    	}else{
			$("#understand").removeClass("selected");
			$("#notUnderstand").removeClass("selected");

	    		if(status == '1'){
	    			document.getElementById("pageNo" + pageNo).className = 'current correct';

	    			$('#understand').addClass('selected');
	    		}else{
	    			document.getElementById("pageNo" + pageNo).className = 'current incorrect';

	    			$('#notUnderstand').addClass('selected');
	    		}

	    		showLevelBar($("#onlineCurriculumId").val());

	    		//showLevelBarForTextPage($("#onlineCurriculumId").val(), resp, status);
	    	}
	    }
	  };
	xhttp.open("GET", "insertTextPageHistory?textPageId=" + textPageId + "&understandStatus=" + status + "&pageNo=" + pageNo, true);
	xhttp.send();
}

function loadSlide(endpoint, textPageId){

	$.ajax({
		type : "GET",
		contentType : "application/json",
		url : "/textSlide/" + endpoint + "?textPageId=" + textPageId,
		dataType : 'json',				
		success : function(data) {
			//let filePath = '/static/slide/ja/jva/' + data["filePath"];
			let filePath = '/slide' + data["filePath"];
			document.getElementById("textPosition").src = filePath;
			$('button.current').removeClass('current');
			let pageNoElem = document.getElementById("pageNo" + data["sort"]);
			$("#understand").removeClass("selected");
			$("#notUnderstand").removeClass("selected");
			if(pageNoElem.classList.contains("correct")){
				$("#understand").addClass("selected");
			}
			else if(pageNoElem.classList.contains("incorrect")){
				$("#notUnderstand").addClass("selected");
			}
			var className = pageNoElem.className;

			document.getElementById("pageNo" +  data["sort"]).className = className + " current";
			document.getElementById("currTex").value = data["textPageId"];
			document.getElementById("currPaNo").value = data["sort"];
			document.getElementById("textContent").innerHTML = data["content"];
			console.log(data["content"]);
			checkShowNextPrevIcon();
		}
	});
}

function getCurrentTextId(){
	const currTex = document.getElementById("currTex");
	if(currTex == null){
		return;
	}
	const textPageId = currTex.value;
	return textPageId;
}

export function loadCurrentSlide(textPageId, pageNo){
	loadSlide("loadSlide", textPageId);
}

export function loadNextSlide(){

	loadSlide("loadNextSlide", getCurrentTextId());
}

export function loadPreviousSlide(){
	
	loadSlide("loadPreviousSlide", getCurrentTextId());
}

export function checkShowNextPrevIcon(){
	const currPage = document.getElementById("currPaNo").value;
	const textPageListSize = document.getElementById("texLisSiz").value;
	if(currPage == '1'){
		document.getElementById("prev-icon").style.display = "none";
	}else{
		document.getElementById("prev-icon").style.display = "inline-block";
	}
	if(currPage == textPageListSize){
		document.getElementById("next-icon").style.display = "none";
	}else{
		document.getElementById("next-icon").style.display = "inline-block";
	}
}

export function updateViewedText(){
	const texHi = document.getElementById("texHi").value;
	$.ajax({
        type : "GET",
        contentType : "application/json",
        url : "./updateViewedTextPage?texHi=" + texHi,
        dataType : 'json',				
        success : function(data) {
            console.log("ok");
        }
    });
}

export function updateUnderstand(status){
	const texHi = document.getElementById("texHi").value;
	const currPage = document.getElementById("currPaNo").value;

	var xhttp = new XMLHttpRequest();
	xhttp.onreadystatechange = function() {
	    if (this.readyState == 4 && this.status == 200) {
    		var resp = this.responseText;
    	
    		if(status == '1'){
    			document.getElementById("pageNo" + currPage).className = 'current correct';
    			$(document).ready(function() {
    				$('#understand').addClass('selected');
			});
	
	    	}else{
    			document.getElementById("pageNo" + currPage).className = 'current incorrect';
    			$(document).ready(function() {
    				$('#notUnderstand').addClass('selected');
			});
    		}

    		if(resp == 'UPLV'){
    			showLevelBar($("#onlineCurriculumId").val());

	    		showLevelBarForTextPage($("#onlineCurriculumId").val(), texHi, status);
    		}else{
    			document.getElementById("textPage-level-bar-upLevel").innerHTML = "0";
    		}	
	    }
	  };
	xhttp.open("GET", "updateUnderstand?texHi=" + texHi + "&status=" + status, true);
	xhttp.send();
}

export function insertTexPaHiWithLoadSli(textPageId){
    $.ajax({
        type : "GET",
        contentType : "application/json",
        url : "./insertTexPaHiWithLoadSli?texId=" + textPageId,
        dataType : 'json',				
        success : function(data) {
	        document.getElementById("texHi").value = data;
        }
    });
}

export function loadSliWithIns(textPageId, pageNo){
	updateViewedText();

	$.ajax({
	   type : "GET",
	   contentType : "application/json",
	   url : "./loadSlide?textPageId=" + textPageId,
	   dataType : 'json',				
	   success : function(data) {

		   let filePath = '/slide' + data["filePath"];
		   document.getElementById("textPosition").src = filePath;
		   $('button.current').removeClass('current');
		   var className = document.getElementById("pageNo" + pageNo).className;
		   document.getElementById("pageNo" + pageNo).className = className + " current";

	       document.getElementById("currTex").value = textPageId;
	       document.getElementById("currPaNo").value = pageNo;
			$(document).ready(function() {
		  $('#understand').css({'color':'#0CA5E6','background':'linear-gradient(#E3EEFA 0%, #E3EEFA  100%)'});
		  $('#understand').removeClass('selected');
		  $('#notUnderstand').css({'color':'#FF7474','background':'linear-gradient(#FFD8F2 0%, #FFD8F2 100%)'});
		  $('#notUnderstand').removeClass('selected');
	});
			checkShowNextPrevIcon();
	       insertTexPaHiWithLoadSli(textPageId);
	   }
   });
}

export function nextSliWithIns(){
	const textPageId = document.getElementById("currTex").value;
	updateViewedText();

	$.ajax({
		type : "GET",
		contentType : "application/json",
		url : "./loadNextSlide?textPageId=" + textPageId,
		dataType : 'json',				
		success : function(data) {
			//let filePath = '/static/slide/ja/jva/' + data["filePath"];
			let filePath = '/slide' + data["filePath"];
			document.getElementById("textPosition").src = filePath;
			$('button.current').removeClass('current');
			var className = document.getElementById("pageNo" + data["sort"]).className;
            document.getElementById("pageNo" +  data["sort"]).className = className + " current";
            document.getElementById("currTex").value = data["textPageId"];
	        document.getElementById("currPaNo").value = data["sort"];
	        checkShowNextPrevIcon();
			insertTexPaHiWithLoadSli(data["textPageId"]);

			$('#understand').css({'color':'#0CA5E6','background':'linear-gradient(#E3EEFA 0%, #E3EEFA  100%)'});
		  	$('#understand').removeClass('selected');
		  	$('#notUnderstand').css({'color':'#FF7474','background':'linear-gradient(#FFD8F2 0%, #FFD8F2 100%)'});
		  	$('#notUnderstand').removeClass('selected');
		}
    });
}

export function prevSliWithIns(){
	const textPageId = document.getElementById("currTex").value;
	updateViewedText();

    $.ajax({
        type : "GET",
        contentType : "application/json",
        url : "./loadPreviousSlide?textPageId=" + textPageId,
        dataType : 'json',				
        success : function(data) {
            //let filePath = '/static/slide/ja/jva/' + data["filePath"];
            let filePath = '/slide' + data["filePath"];
            document.getElementById("textPosition").src = filePath;
            $('button.current').removeClass('current');
            var className = document.getElementById("pageNo" + data["sort"]).className;
            document.getElementById("pageNo" +  data["sort"]).className = className + " current";
            document.getElementById("currTex").value = data["textPageId"];
	        document.getElementById("currPaNo").value = data["sort"];
	        checkShowNextPrevIcon();
	        insertTexPaHiWithLoadSli(data["textPageId"]);

        }
    });
}